<template>
    <div ref="animationWrapper" :class="{ 'is-overlay': overlay }"></div>
</template>

<script>
import bodymovin from 'lottie-web';
export default {
    props: {
        animation: {
            type: Object,
            default() {
                return undefined;
            },
        },
        loop: {
            type: Boolean,
            default: false,
        },
        overlay: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            lottie: undefined,
        };
    },
    mounted() {
        this.lottie = bodymovin.loadAnimation({
            wrapper: this.$refs.animationWrapper,
            loop: this.loop,
            animationData:
                this.animation || require('@/assets/animations/checkmark.json'),
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid meet',
            },
        });

        this.lottie.addEventListener('complete', () => {
            //console.log('complete animations');
            this.$emit('complete');
        });
    },
    beforeDestroy() {
        this.lottie.removeEventListener('complete');
    },
};
</script>

<style></style>
